module.exports = __webpack_public_path__ + "front/img/edm-btn.23f36d4b.png";